import { Box, Typography } from '@mui/material';
import RetailersContainer from '@/features/retailers/components/RetailersContainer';

export default function RetailersPage() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Mantenedor de Retailers
      </Typography>
      <RetailersContainer />
    </Box>
  );
}
